import styled from "styled-components";
export const Wrapper = styled.div `
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 220px;
`;
export const FixedItem = styled.div `
  align-items: stretch;
  display: flex;
  flex-direction: column;
  width: 60px;
`;
